import { InputSelect } from '@/components/common/Input'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { CARDTYPE_LABELS, type CardtypeType } from '@/defs/mtg'
import { SCROLL_GALLERY } from '@/defs/scroll'
import { useLinkInternal } from '@/hooks/useLinkInternal'

export const FilterInputCardtype = () => {
  const { redirectRelative } = useLinkInternal()
  const { page } = usePage()

  const route = page?.route
  const cardtypeOptions = page?.optionsFilters?.cardtypes

  if (!cardtypeOptions) return null

  const options = cardtypeOptions.map((cardtype) => ({
    label: <IconWithLabel iconBefore={CARDTYPE_LABELS[cardtype].icon}>{CARDTYPE_LABELS[cardtype].label}</IconWithLabel>,
    value: cardtype,
  }))

  const onSelect = (cardtype: CardtypeType) => {
    if (cardtype !== route?.cardtype) redirectRelative({ cardtype }, { scroll: SCROLL_GALLERY })
  }

  return <InputSelect onSelect={onSelect} options={options} placeholder='Choose a card type' value={route?.cardtype} />
}
